// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type WebOrdersQueryVariables = Types.Exact<{
  input: Types.WebOrdersInput;
}>;


export type WebOrdersQuery = { __typename?: 'Query', webOrders: { __typename?: 'WebOrdersPayload', orders: Array<{ __typename?: 'Order', orderId?: string | null, readableOrderId?: string | null, orderDate: number, orderedBy: string, status: string, statusAlias: string, statusCategory?: string | null, salesDocNumber?: string | null, poNumber?: string | null, total: number, currency: string, sysId?: string | null, quotePriceItemExists?: boolean | null, orderType?: string | null, totalItems?: number | null, totalCompletedItems?: number | null, soldTo?: string | null }> } };

export type WebOrdersOrderFragment = { __typename?: 'Order', orderId?: string | null, readableOrderId?: string | null, orderDate: number, orderedBy: string, status: string, statusAlias: string, statusCategory?: string | null, salesDocNumber?: string | null, poNumber?: string | null, total: number, currency: string, sysId?: string | null, quotePriceItemExists?: boolean | null, orderType?: string | null, totalItems?: number | null, totalCompletedItems?: number | null, soldTo?: string | null };

export type WebOrdersPayloadFragment = { __typename?: 'WebOrdersPayload', orders: Array<{ __typename?: 'Order', orderId?: string | null, readableOrderId?: string | null, orderDate: number, orderedBy: string, status: string, statusAlias: string, statusCategory?: string | null, salesDocNumber?: string | null, poNumber?: string | null, total: number, currency: string, sysId?: string | null, quotePriceItemExists?: boolean | null, orderType?: string | null, totalItems?: number | null, totalCompletedItems?: number | null, soldTo?: string | null }> };

export const WebOrdersOrderFragmentDoc = gql`
    fragment WebOrdersOrder on Order {
  orderId
  readableOrderId
  orderDate
  orderedBy
  status
  statusAlias
  statusCategory
  salesDocNumber
  poNumber
  total
  currency
  sysId
  quotePriceItemExists
  orderType
  totalItems
  totalCompletedItems
  soldTo
}
    `;
export const WebOrdersPayloadFragmentDoc = gql`
    fragment WebOrdersPayload on WebOrdersPayload {
  orders {
    ...WebOrdersOrder
  }
}
    ${WebOrdersOrderFragmentDoc}`;
export const WebOrdersDocument = gql`
    query WebOrders($input: WebOrdersInput!) {
  webOrders(input: $input) {
    ...WebOrdersPayload
  }
}
    ${WebOrdersPayloadFragmentDoc}`;
export type WebOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WebOrdersQuery, WebOrdersQueryVariables>, 'query'> & ({ variables: WebOrdersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WebOrdersComponent = (props: WebOrdersComponentProps) => (
      <ApolloReactComponents.Query<WebOrdersQuery, WebOrdersQueryVariables> query={WebOrdersDocument} {...props} />
    );
    

/**
 * __useWebOrdersQuery__
 *
 * To run a query within a React component, call `useWebOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebOrdersQuery(baseOptions: Apollo.QueryHookOptions<WebOrdersQuery, WebOrdersQueryVariables> & ({ variables: WebOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebOrdersQuery, WebOrdersQueryVariables>(WebOrdersDocument, options);
      }
export function useWebOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebOrdersQuery, WebOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebOrdersQuery, WebOrdersQueryVariables>(WebOrdersDocument, options);
        }
export function useWebOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOrdersQuery, WebOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebOrdersQuery, WebOrdersQueryVariables>(WebOrdersDocument, options);
        }
export type WebOrdersQueryHookResult = ReturnType<typeof useWebOrdersQuery>;
export type WebOrdersLazyQueryHookResult = ReturnType<typeof useWebOrdersLazyQuery>;
export type WebOrdersSuspenseQueryHookResult = ReturnType<typeof useWebOrdersSuspenseQuery>;
export type WebOrdersQueryResult = Apollo.QueryResult<WebOrdersQuery, WebOrdersQueryVariables>;